import React, { useRef } from 'react'

import emailjs from '@emailjs/browser';
import { toast } from 'react-hot-toast';
const Contact = () => {

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_7ely6pd', 'template_5m3xv1y', form.current, 'P89cKDP7VgkMTWL7S')
      .then((result) => {
          console.log(result.text);
          toast.success('Successfully sent')
          form.reset()
      }, (error) => {
          console.log(error.text);
      });
  };
  return (
    // <div name='contact' className='w-full h-screen bg-[#0a192f] flex justify-center items-center p-4'>
    //     <form method='POST' action="https://getform.io/f/a699a1b2-f225-434e-b317-1fbbde8e006c" className='flex flex-col max-w-[600px] w-full'>
    //         <div className='pb-8'>
    //             <p className='text-4xl font-bold inline border-b-4 border-pink-600 text-gray-300'>Contact</p>
    //             <p className='text-gray-300 py-4'>// Submit the form below or shoot me an email - vutukuri.kumar192st.niituniversity.in</p>
    //         </div>
    //         <input className='bg-[#ccd6f6] p-2' type="text" placeholder='Name' name='name' />
    //         <input className='my-4 p-2 bg-[#ccd6f6]' type="email" placeholder='Email' name='email' />
    //         <textarea className='bg-[#ccd6f6] p-2' name="message" rows="10" placeholder='Message'></textarea>
    //         <button className='text-white border-2 hover:bg-pink-600 hover:border-pink-600 px-4 py-3 my-8 mx-auto flex items-center'>Let's Collaborate</button>
    //     </form>
    // </div>
    <div
      name="contact"
      className="w-full h-screen bg-[#0a192f] text-white"
    >
      <div className="flex flex-col p-4 justify-center max-w-screen-lg mx-auto h-full">
        <div className="pb-8">
 
          <p className='text-4xl font-bold inline border-b-4 border-pink-600 text-gray-300'>Contact</p>
          <p className='text-gray-300 py-4'>// Submit the form below or shoot me an email - shaonkhairul@gmail.com</p>
        </div>

        <div className=" flex justify-center items-center">
        <form ref={form} onSubmit={sendEmail} method='POST' action="https://getform.io/f/a699a1b2-f225-434e-b317-1fbbde8e006c" className='flex flex-col max-w-[600px] w-full'>

            <input className='bg-[#ccd6f6] p-2 text-black' type="text" placeholder='Name' name='user_name' />
            <input className='my-4 p-2 bg-[#ccd6f6] text-black' type="email" placeholder='Email' name='user_email' />
            <textarea className='bg-[#ccd6f6] p-2 text-black' name="message" rows="10" placeholder='Message'></textarea>
            {/* <input type="submit" value="Send" className='text-white border-2 hover:bg-pink-600 hover:border-pink-600 px-4 py-3 my-8 mx-auto flex items-center'>Let's Collaborate</input> */}
            <input type="submit" className='text-white border-2 hover:bg-pink-600 hover:border-pink-600 px-4 py-3 my-8 mx-auto flex items-center' value="Let's Collaborate" />
        </form>
        </div>
      </div>
    </div>
  )
}

export default Contact